import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyB_-VPHtRdr98Pi9v89R9wlZuvSKHVsX2U",
  authDomain: "jigsolve-3dc25.firebaseapp.com",
  projectId: "jigsolve-3dc25",
  storageBucket: "jigsolve-3dc25.appspot.com",
  messagingSenderId: "643437935397",
  appId: "1:643437935397:web:230a28d4f179b0458938cc"
};

initializeApp(firebaseConfig);